import FileImportLocations from 'components/FileImport/FileImportLocations'
import PageLayout from '../components/layout/PageLayout'
import LocationsList from 'components/lists/locations/LocationsList'
import { useSession } from 'providers/SessionProvider';

export default function LocationsPage() {
  const { stores} = useSession();
  return (
    <PageLayout 
    pageTitle='Ubicaciones' 
    pageDesc='Altas, bajas y modificaciones.'
    importButton={
      <FileImportLocations
        stores={stores}
      />
    }>
      <LocationsList/>
    </PageLayout>
  )
}